import { resetAndAddClass } from '../../utils/resetAndAddClass.js'
import { activateScreen } from '../../utils/activateScreen.js'
import { showBackArrow } from '../../utils/showBackArrow.js'
import { hideBackArrow } from '../../utils/hideBackArrow.js'

export const handleViewChange = (tab, view, previousView, singleChannel, callMeNowActive) => {
  switch (tab) {
    case 'callback':
      showBackArrow()
      if (view === null) {
        activateScreen('cce-widget-callback', 'start')
        document.querySelector('.cce-widget__window__header').classList.remove('cce-widget__window--with-pre-interaction-form')
        if (singleChannel) {
          hideBackArrow()
        }
      } else if (view === 'schedule') {
        activateScreen('cce-widget-callback', 'schedule')
        document.querySelector('.cce-widget__window__header').classList.remove('cce-widget__window--with-pre-interaction-form')
        if (singleChannel && !callMeNowActive) {
          hideBackArrow()
        }
      } else if (view === 'pre-interaction-form') {
        activateScreen('cce-widget-callback', 'pre-interaction-form')
      } else if (view === 'schedule-pre-interaction-form') {
        activateScreen('cce-widget-callback', 'pre-interaction-form')
      } else if (view === 'thanks') {
        activateScreen('cce-widget-callback', 'thanks')
      }
      break

    case 'chat':
      const chatContainer = document.querySelector('.cce-widget-chat')
      const headerContainer = document.querySelector('.cce-widget__window__header')
      if (!chatContainer) return
      showBackArrow()

      if (view === null) {
        chatContainer.classList.remove('formOpen')
        headerContainer.classList.remove('cce-widget__window--with-pre-interaction-form')
        if (singleChannel) {
          hideBackArrow()
        }
      } else if (view === 'pre-interaction-form') {
        chatContainer.classList.add('formOpen')
        headerContainer.classList.add('cce-widget__window--with-pre-interaction-form')
        if (singleChannel) {
          hideBackArrow()
        }
      }
      break

    case 'audio':
      const audioContainer = document.querySelector('.cce-widget-audio')
      if (!audioContainer) return

      resetAndAddClass('.cce-widget-audio', ['cce-widget-audio', 'open'])
      showBackArrow()

      if (view === null) {
        audioContainer.classList.add('initiated')
        if (singleChannel) {
          hideBackArrow()
        }
      } else {
        audioContainer.classList.add(view)
      }
      if (view === 'ringing' || view === 'in-progress' || view === 'dial' || view === 'settings') {
        hideBackArrow()
      }
      break

    case 'video':
      const videoContainer = document.querySelector('.cce-widget-video')
      if (!videoContainer) return

      resetAndAddClass('.cce-widget-video', ['cce-widget-video', 'open'])
      showBackArrow()

      if (view === null) {
        videoContainer.classList.add('initiated')
        if (singleChannel) {
          hideBackArrow()
        }
      } else {
        videoContainer.classList.add(view)
      }
      if (view === 'ringing' || view === 'in-progress' || view === 'dial' || view === 'settings') {
        hideBackArrow()
      }
      break

    case 'scheduledVideo':
      const scheduledVideoContainer = document.querySelector('.cce-widget-scheduledVideo')
      if (!scheduledVideoContainer) return
      showBackArrow()
      if (view === null) {
        activateScreen('cce-widget-scheduledVideo', 'schedule')
        document.querySelector('.cce-widget__window__header').classList.remove('cce-widget__window--with-pre-interaction-form')
        if (singleChannel) {
          hideBackArrow()
        }
      } else if (view === 'pre-interaction-form') {
        activateScreen('cce-widget-scheduledVideo', 'pre-interaction-form')
      } else if (view === 'thanks') {
        activateScreen('cce-widget-scheduledVideo', 'thanks')
      }
      break
  }
}
